export default __webpack_public_path__ + "static/media/567.dd14a03e.png";